// Mlle Créative – Empêche l'ajout au panier automatique quand on clique sur un champ TEPO
document.addEventListener('DOMContentLoaded', () => {
  // Intercepter très tôt (phase capture) les changements dans les champs TEPO
  document.addEventListener('change', (e) => {
    if (e.target && e.target.closest('.tepo-field')) {
      // Stoppe les écouteurs "change" du thème qui font un add-to-cart automatique
      e.stopImmediatePropagation();
    }
  }, true);

  // Sécurité : bloquer toute soumission déclenchée par erreur depuis un champ TEPO
  const forms = document.querySelectorAll('form[action*="/cart/add"]');
  forms.forEach((form) => {
    form.addEventListener('submit', (e) => {
      const active = document.activeElement;
      if (active && active.closest && active.closest('.tepo-field')) {
        e.preventDefault();
        e.stopImmediatePropagation();
      }
    }, true);
  });
});
